import {createReducer} from "./index";
import {ADD_NOTIFICATIONS, API_GET_NOTIFICATIONS_DONE, REMOVE_NOTIFICATIONS} from "../actions/notifications";
import * as R from 'ramda';

/* shape of the notifications model

{
  data: {
    [id]: {
      historyid,
      contactuserid,
      associatedid,
      datecreated,
      createbyuserid,
      createdbycompanyid,
      segmenttype: "chat"
      fields,
      comment,
      associationtype,
    }
  }
}


 */

const initial = {
  data: {

  }
};

const notificationsReducer = createReducer(initial,
  {
    [ADD_NOTIFICATIONS]: (state, action) => {
      let { notifications } = action.payload;
      for (let notification of notifications) {
        if (state.data[notifications.historyid]) continue;
        state = R.set(R.lensPath(['data', notification.historyid]), notification, state);
      }
      return state;
    },
    [REMOVE_NOTIFICATIONS]: (state, action) => {
      let { notificationIds } = action.payload;
      for (let id of notificationIds) {
        state = R.dissocPath(['data', id], state);
      }
      return state;
    }
    // 'ACTION_NAME': function (state, action) -> new_state
  });

export default notificationsReducer;



// WEBPACK FOOTER //
// ./src/reducers/notifications.js